export * from "svg-pathdata";
